import {defineStore} from 'pinia'

export type Notification = {
    id: number
    type: string
    data: {
        content: string
    }
    created_at: string
    read_at: string | null
}

export const useNotificationStore = defineStore('notifications', () => {

    const timeline = useAsyncState(() => $lara.get('/app/spa/notifications') as Promise<Notification[]>, [])

    const unreadNotificationsCount = computed(() => {
        return timeline.state.value.filter(notification => !notification.read_at).length
    })

    async function markAllAsRead() {
        await $lara.put('/app/spa/notifications/markAsRead')
        await timeline.execute()
    }

    async function refreshTimeline() {
        await timeline.execute()
    }

    return {
        timeline,
        unreadNotificationsCount,
        markAllAsRead,
        refreshTimeline
    }
})